/**
 * UI Store — lightweight global UI state (mobile sidebar, etc.)
 */
import { create } from 'zustand';

export const useUIStore = create((set) => ({
  mobileSidebarOpen: false,
  openMobileSidebar: () => set({ mobileSidebarOpen: true }),
  closeMobileSidebar: () => set({ mobileSidebarOpen: false }),
  toggleMobileSidebar: () => set((s) => ({ mobileSidebarOpen: !s.mobileSidebarOpen })),

  // Team panel trigger — set by ProjectLayout header, consumed by Artboard
  mobileTeamPanelRequested: false,
  requestMobileTeamPanel: () => set({ mobileTeamPanelRequested: true }),
  clearMobileTeamPanelRequest: () => set({ mobileTeamPanelRequested: false }),
}));
